<template>
    <div class="hello">
        <el-form :model="account" label-width="200px" :rules="rules" ref="passForm" class="supplier-form">
            <el-form-item label="原密码：" prop="oldPassword"><el-input type="password" v-model="account.oldPassword" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="新密码：" prop="newPassword"><el-input type="password" v-model="account.newPassword" auto-complete="off"></el-input></el-form-item>
            <el-form-item label="确认密码：" prop="newPassword2"><el-input type="password" v-model="account.newPassword2" auto-complete="off"></el-input></el-form-item>
        </el-form>
        <div class="text-center">
            <el-button :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
    </div>
</template>

<script type="text/babel">
    import { mapGetters } from 'vuex'
    import apis from '@/store/apis'

    export default {
        name: 'supplier-password',
        data () {
            return {
                account: {
                    oldPassword:'',
                    newPassword:'',
                    newPassword2:''
                },
                isSubmit:false,
                rules:{
                    oldPassword: [
                        {required: true, message: '请输入原密码', trigger: 'blur'},
                        {min: 3, message: '至少 3 位密码', trigger: 'blur'}
                    ],
                    newPassword: [
                        {required: true, message: '请输入新密码', trigger: 'blur'},
                        {min: 6, message: '至少 6 位密码', trigger: 'blur'}
                    ],
                    newPassword2: [
                        { required: true, message: '请再次输入新密码', trigger: 'blur'},
                        { validator: this.validatePass, trigger: 'blur' }
                    ]
                }
            }
        },
        computed: mapGetters(['user']),
        props: {
            callback: {
                type: Function
            }
        },
        methods: {
            validatePass(rule, value, callback){
                if (value === '') {
                    callback(new Error('请再次输入密码'))
                } else if (value !== this.account.newPassword) {
                    callback(new Error('两次输入密码不一致!'))
                } else {
                    callback()
                }
            },
            submit(){
                this.$refs.passForm.validate(valid=>{
                    if(valid){
                    	this.isSubmit=true;
                        apis.updatePass({loginName:this.user.floginnum,oldPassword: this.account.oldPassword, newPassword: this.account.newPassword})
                            .then(res=>{
                            if (res.data.result) {
                                this.$confirm('操作成功！', '提示', {
                                    confirmButtonText: '确定',
                                    showCancelButton: false,
                                    showClose: false,
                                    type: 'success',
                                    center: true
                                }).then(() => {
                                	this.isSubmit=false;
                                    this.callback && this.callback()
                                })
                            }else{
                            	this.isSubmit=false;
                                this.$alert(res.data.message)
                            }
                        }, err=>{
                        	this.isSubmit=false;
                        	this.$alert(err)
                        })
                    }
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Password.vue